
export { LucideIcon } from "/codebuild/output/src3467526221/src/packages/shared-components/src/components/LucideIcon.tsx"